import { useContext } from "react";
import {LangContext} from "./AppContext";


export default function Popover({point, country, onClose}){
  const {lang} = useContext(LangContext);

  if (!point)
  return null;

  const direction = point.vertical ? 'is-horizontal' : 'is-vertical';

  return (
      <>
<div id="popover-overlay">

</div>
    <div id="pop-over" className={`${direction} absolute z-10 `}>
        <button id="pop-over__close-btn" className="absolute right-2 top-2 " onClick={onClose}><img src="assets/imgs/btn-close.svg" alt=""/></button>
        <figure className="pop-over__image">
            <picture>
                <img src={`assets/imgs/${point.image}`} alt=""/>
            </picture>
        </figure>

        <div id="pop-over-txt" className={`pop-over__text text-center  cat-${point.category}`}>
            <h2 className="">{point.cat[`name_${lang}`]}</h2>
            <h1 >{country && country[`name_${lang}`]}</h1>
            <div className="content" dangerouslySetInnerHTML={{__html:point[`text_${lang}`]}}></div>
        </div>

    </div>
      </>
  );
}
